var modules_2fceba91 = {"card":"DownloadApp_module_card__74713aa5","noWrap":"DownloadApp_module_noWrap__74713aa5","minContent":"DownloadApp_module_minContent__74713aa5","text":"DownloadApp_module_text__74713aa5","qrWrapper":"DownloadApp_module_qrWrapper__74713aa5","qr":"DownloadApp_module_qr__74713aa5","dark":"DownloadApp_module_dark__74713aa5"};
import "../../../assets/esm/components/DownloadApp/src/DownloadApp~Dy6N5SIV.css";

export { modules_2fceba91 as default };
//# sourceMappingURL=DownloadApp.module.less.js.map
